import {
  ADDITIONAL_DEPENDENT_PROPERTIES,
  attachCustomsInfoSelector,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import {FEDEX, FEDEX_360, UPS} from '../../../common/constants/ShipperNames.js'
import ConfigTextInput from './ConfigTextInput.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {useSelector, getState} from '../../../store.js'

const LABEL_PROPERTY = 'purchase_order_number'
const VALID_SHIPPER_TYPES = [FEDEX, FEDEX_360, UPS]

function dependentPropertiesFunc(shipperType) {
  return shipperType === UPS
    ? [...ADDITIONAL_DEPENDENT_PROPERTIES, LABEL_PROPERTY_ATTACH_CUSTOMS_INFO]
    : ADDITIONAL_DEPENDENT_PROPERTIES
}

export function exportPurchaseOrderNumberLabelPropertiesFunc(
  shipperType,
  labelInfoID,
) {
  const attachCustomsInfo = attachCustomsInfoSelector(getState(), {labelInfoID})

  return shipperType !== UPS || attachCustomsInfo ? [LABEL_PROPERTY] : []
}

export default function PurchaseOrderNumber() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const [propertySpecs] = PurchaseOrderNumber.propertySpecList
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  const attachCustomsInfo = useSelector((state) =>
    attachCustomsInfoSelector(state, {labelInfoID}),
  )

  return (
    <ConfigTextInput
      label="Purchase Order Number"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: value})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      hide={shipperType === UPS && !attachCustomsInfo}
    />
  )
}

PurchaseOrderNumber.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: exportPurchaseOrderNumberLabelPropertiesFunc,
    dependentPropertiesFunc,
    validLabelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
  },
]
